import { CKTooltip } from '@clearkit/react';
import moment from 'moment';

const format = 'dddd, MMMM Do YYYY, h:mm:ss A';

export default function TimeAgo({ time, ...props }) {
  const timeAgo = moment(time).fromNow();
  const title = moment(time).format(format);

  return (
    <CKTooltip tooltip={title} unstable_portal={false}>
      <time dateTime={time} {...props}>
        {timeAgo}
      </time>
    </CKTooltip>
  );
}

TimeAgo.propTypes = {
  time: PropTypes.string.isRequired,
};
